
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import React, { useState, useEffect, useRef } from 'react'
import * as Papa from 'papaparse';

const allowedExtensions = ["csv"];

function CSVAuswertung({ }) {
    //ind_3064_Feld_adressen86 leadart
    //ind_3070_Feld_adressen88 veranstaltungsdatum
    //ind_2576_Feld_adressen73 akquisestufe


    const [leadartenstats, setLeadartenStats] = useState()
    const [veranstaltungsstats, setVeranstaltungsStats] = useState()
    const [akquisiteursstats, setAkquisiteursStats] = useState()

    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [file, setFile] = useState("");

    // This function will be called when
    // the file input changes
    const handleFileChange = (e) => {
        setError("");

        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = e.target.files[0];

            // Check the file extensions, if it not
            // included in the allowed extensions
            // we show the error
            const fileExtension =
                inputFile?.type.split("/")[1];
            if (
                !allowedExtensions.includes(fileExtension)
            ) {
                setError("Please input a csv file");
                return;
            }

            // If input type is correct set the state
            setFile(inputFile);
        }
    };
    const handleParse = () => {
    
        // If user clicks the parse button without
        // a file we show a error
        if (!file) return alert("Enter a valid file");

        // Initialize a reader which allows user
        // to read any file or blob.
        const reader = new FileReader();

        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, {
                header: true,
            });
            const parsedData = csv?.data;
            const rows = Object.keys(parsedData[0]);

            const columns = Object.values(parsedData[0]);
            const res = rows.reduce((acc, e, i) => {
                return [...acc, [[e], columns[i]]];
            }, []);
            console.log(res);
            setData(res);
        };
        reader.readAsText(file);
    };


    return (
        <>
<label
                    htmlFor="csvInput"
                    style={{ display: "block" }}
                >
                    Enter CSV File
                </label>
                <input
                    onChange={handleFileChange}
                    id="csvInput"
                    name="file"
                    type="File"
                />
                <div>
                    <button onClick={handleParse}>
                        Parse
                    </button>
                </div>

            {leadartenstats && <div style={{ width: "90vw", height: "30vh", marginBottom: "40px" }}>
                <h4>Leadart</h4>
                <ResponsiveContainer >
                    <BarChart
                        width={500}
                        height={300}
                        data={leadartenstats}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" angle={0} tick={{ textAnchor: "middle", dy: "20", fontSize: "12px" }} />
                        <YAxis interval="1" />
                        <Tooltip content={"test"} />
                        {/* <Legend /> */}
                        <Bar dataKey="erfolglos" stackId="a" stroke="#000" fill="black" strokeWidth={1} activeBar={<Rectangle fill="black" opacity={1} stroke="black" />} />
                        <Bar dataKey="erfolgreich" stackId="a" stroke="#000" fill="#0d0" strokeWidth={1} activeBar={<Rectangle fill="#0e0" opacity={1} stroke="black" />} />
                        <Bar dataKey="offen" stackId="a" stroke="#000" fill="#ec0" strokeWidth={1} activeBar={<Rectangle fill="#fd0" opacity={1} stroke="black" />} />
                        <Bar dataKey="unerreicht" stackId="a" stroke="#000" fill="#d00" strokeWidth={1} activeBar={<Rectangle fill="#e00" opacity={1} stroke="black" />} />
                    </BarChart>
                </ResponsiveContainer></div>}

            
        </>
    );

}

export default CSVAuswertung;